import { transparentize } from 'polished';
import styled from 'styled-components';
import { spacing2x } from '../../../styles/spacing.js';
import { CONTENT_CARD_ERROR_MESSAGES } from '../constants.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var HeaderOverlayMask = styled.div.withConfig({
  displayName: "ContentCardExhibit__HeaderOverlayMask",
  componentId: "sc-1xa2iow-0"
})(["&&{background-color:", ";bottom:0;left:0;opacity:0;position:absolute;right:0;top:0;}"], function (props) {
  return transparentize(0.5, props.theme.neutralColors.charcoal);
});
var HeaderOverlayBackground = styled.div.withConfig({
  displayName: "ContentCardExhibit__HeaderOverlayBackground",
  componentId: "sc-1xa2iow-1"
})(["&&{background-image:url(", ");background-position-x:center;background-position-y:center;background-repeat:no-repeat;background-size:contain;height:100%;inset-inline-start:0;position:absolute;top:0;width:100%;}"], function (props) {
  return props.$src;
});
var HeaderOverlayBlur = styled.div.withConfig({
  displayName: "ContentCardExhibit__HeaderOverlayBlur",
  componentId: "sc-1xa2iow-2"
})(["&&{background-color:", ";background-image:url(", ");background-size:cover;filter:blur(80px);height:100%;width:100%;}"], function (props) {
  return props.theme.neutralColors.silver;
}, function (props) {
  return props.$src;
});
var Container = styled.div.withConfig({
  displayName: "ContentCardExhibit__Container",
  componentId: "sc-1xa2iow-3"
})(["&&{border-top-left-radius:", ";border-top-right-radius:", ";height:100%;overflow:hidden;position:relative;width:100%;}"], spacing2x, spacing2x);
var ContentCardExhibit = function ContentCardExhibit(props) {
  var exhibit = props.exhibit,
    src = props.src;
  if (!exhibit && !src) {
    console.error(CONTENT_CARD_ERROR_MESSAGES.SRC_OR_EXHIBIT_MUST_BE_PROVIDED);
    return null;
  }
  var content;
  if (exhibit) {
    content = exhibit;
  } else {
    content = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(HeaderOverlayBlur, {
        $src: src
      }), /*#__PURE__*/jsx(HeaderOverlayBackground, {
        $src: src
      }), /*#__PURE__*/jsx(HeaderOverlayMask, {})]
    });
  }
  return /*#__PURE__*/jsx(Container, {
    children: content
  });
};
ContentCardExhibit.displayName = "ContentCardExhibit";

export { ContentCardExhibit, HeaderOverlayMask };
